export type NormalizedRotation = 0 | 90 | 180 | 270;

export type PageCropRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export function normalizeRotation(angle: number): NormalizedRotation {
  const normalized = ((Math.round(angle) % 360) + 360) % 360;
  if (normalized === 90) return 90;
  if (normalized === 180) return 180;
  if (normalized === 270) return 270;
  return 0;
}

/**
 * Вертикальный разрез в том виде, как страницу видит пользователь.
 * Crop задаётся в координатах MediaBox (без учёта /Rotate).
 * Для Rotate 90/270 «вертикаль» в viewer = разрез по высоте MediaBox.
 */
export function getVisualVerticalCropHalves(
  media: PageCropRect,
  rotation: NormalizedRotation
): [PageCropRect, PageCropRect] {
  const { x, y, width, height } = media;
  const halfWidth = width / 2;
  const halfHeight = height / 2;

  switch (rotation) {
    case 0:
      return [
        { x, y, width: halfWidth, height },
        { x: x + halfWidth, y, width: halfWidth, height },
      ];
    case 180:
      return [
        { x: x + halfWidth, y, width: halfWidth, height },
        { x, y, width: halfWidth, height },
      ];
    case 90:
      // Rotate 90 CW: низ MediaBox → визуально слева, верх → справа
      return [
        { x, y, width, height: halfHeight },
        { x, y: y + halfHeight, width, height: halfHeight },
      ];
    case 270:
      // Rotate 270 CW: верх MediaBox → визуально слева, низ → справа
      return [
        { x, y: y + halfHeight, width, height: halfHeight },
        { x, y, width, height: halfHeight },
      ];
    default: {
      const neverRotation: never = rotation;
      throw new Error(`Unsupported rotation: ${String(neverRotation)}`);
    }
  }
}
